import Cookies from 'js-cookie';

import { isDevEnvironmentSwitcherEnabled } from './environments';

const COOKIE_KEY = 'DEV_LOCAL_FORM_FRAGMENT';
const cookieOptions = { path: '/' };

export const LOCAL_FORM_FRAGMENT_COOKIE_KEY = COOKIE_KEY;
export const IBERFLUID_FORM_GUID = '5B735895-BC2B-444F-AE43-3C0C5586CB83';
export const LOCAL_FORM_FRAGMENT_PORT = 3010;
export const LOCAL_FORM_FRAGMENT_IFRAME_URL = `https://localhost:${LOCAL_FORM_FRAGMENT_PORT}`;

const isLocalHost = (win = window) => {
    const hostname = win?.location?.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
};

const formatLocalHost = (hostname) => (hostname.includes(':') ? `[${hostname}]` : hostname);

export const isLocalFormFragmentAvailable = () => isDevEnvironmentSwitcherEnabled();

export const isLocalFormFragmentEnabled = (win = window) => {
    if (!isLocalFormFragmentAvailable(win)) return false;
    return Cookies.get(COOKIE_KEY) === '1';
};

export const setLocalFormFragmentEnabled = (enabled, win = window) => {
    if (!isLocalFormFragmentAvailable(win)) return;

    if (enabled) {
        Cookies.set(COOKIE_KEY, '1', cookieOptions);
        return;
    }

    Cookies.remove(COOKIE_KEY, cookieOptions);
};

export const getLocalFormFragmentIframeUrl = (win = window) => {
    if (!isLocalHost(win)) {
        return LOCAL_FORM_FRAGMENT_IFRAME_URL;
    }

    const protocol = win?.location?.protocol === 'http:' ? 'http:' : 'https:';
    const hostname = win?.location?.hostname || 'localhost';

    return `${protocol}//${formatLocalHost(hostname)}:${LOCAL_FORM_FRAGMENT_PORT}`;
};

export const getLocalFormFragmentOverrides = (win = window) => {
    if (!isLocalFormFragmentEnabled(win)) return null;

    return {
        [IBERFLUID_FORM_GUID]: getLocalFormFragmentIframeUrl(win),
    };
};
